import { FaChevronDown, FaChevronUp } from "react-icons/fa";
import { useState } from "react";
import { Table } from "react-bootstrap";
import "./style.css";

const ProductInfoTable = (props: any) => {
  const alwaysExpand = props.alwaysExpand ?? false;

  const [isExpanded, setExpanded] = useState(false);

  const handleOnClick = () => {
    if (alwaysExpand) return;
    setExpanded(!isExpanded);
  };

  //Add logic to organize prop data

  return (
    <div className="panel panel-default">
      <div className="panel-heading" onClick={handleOnClick}>
        {alwaysExpand && (
          <span className="panel-title panel-title-colored">{props.title}</span>
        )}
        {!alwaysExpand && (
          <>
            <div className="panel-title-container col-lg-4 col-md-8 col-11">
              <a className="panel-title">{props.title}</a>
              {isExpanded ? <FaChevronUp /> : <FaChevronDown />}
            </div>
            <div className="col-lg-8 col-md-4 col-1">&nbsp;</div>
          </>
        )}
      </div>
      <div
        className={
          alwaysExpand || isExpanded ? "panel-body" : "panel-body-collapsed"
        }
      >
        <Table bordered hover size="md" id="product-info-table">
          <tbody key="info-table-body">
            {props.columns &&
              props.columns.map((column: any, index: number) => {
                return (
                  <tr key={props.title + "_" + column.title + index}>
                    <td id="info-table-key" className="w-30">
                      {column.title}
                    </td>
                    <td id="info-table-value">
                      {column.value ? column.value : column.rawValue}
                    </td>
                  </tr>
                );
              })}
          </tbody>
        </Table>
      </div>
    </div>
  );
};

export default ProductInfoTable;
